import { render, staticRenderFns } from "./ConfirmDeleteOverlay.vue?vue&type=template&id=5a1f42f5&scoped=true"
import script from "./ConfirmDeleteOverlay.vue?vue&type=script&lang=js"
export * from "./ConfirmDeleteOverlay.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a1f42f5",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5a1f42f5')) {
      api.createRecord('5a1f42f5', component.options)
    } else {
      api.reload('5a1f42f5', component.options)
    }
    module.hot.accept("./ConfirmDeleteOverlay.vue?vue&type=template&id=5a1f42f5&scoped=true", function () {
      api.rerender('5a1f42f5', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/ConfirmDeleteOverlay.vue"
export default component.exports